export const MAXIMUM_UPLOADED_DOMAINS = 5_000_000;
export const MAXIMUM_UPLOADED_FILES = 5;
